WeightedTable = function () {
  this._outcomes = [];
  this._totalWeight = 0;

  this.addOutcome = function (outcomeToAdd, chanceToAdd) {
    this._outcomes.push({
      outcome: outcomeToAdd,
      chance: chanceToAdd,
    });
    this._totalWeight += chanceToAdd;
  };

  this.addSymbolRules = function (type, symbolRules) {
    let keys = Object.keys(symbolRules);
    let symId = parseInt(keys[0], 10);
    for (let i = 0; i < this._outcomes.length; i++) {
      if (this._outcomes[i].outcome === symId) {
        if (type === "distance") {
          if (this._outcomes[i].rules === undefined) {
            this._outcomes[i].rules = {};
          }
          if (this._outcomes[i].rules.distance === undefined) {
            this._outcomes[i].rules.distance = {};
          }
          this._outcomes[i].rules.distance = symbolRules[keys[0]];
        }
      }
    }
  };

  this.getSymbolRule = function (id) {
    for (let i = 0; i < this._outcomes.length; i++) {
      const outcome = this._outcomes[i];
      if (outcome.outcome === id) {
        if (outcome.rules !== undefined) {
          return outcome.rules;
        }
      }
    }
  };

  this.pickOutcome = function () {
    let runningTotal = 0;
    let selectedOutcome = Math.floor(Math.random() * this._totalWeight);

    for (let i = 0; i < this._outcomes.length; ++i) {
      runningTotal += this._outcomes[i].chance;
      if (runningTotal > selectedOutcome) {
        return this._outcomes[i];
      }
    }
  };
};
